/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import { Input, InputNumber } from 'antd';
import { Radio } from 'antd';
import { debounce } from 'lodash';

class Inputlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            error: [],
            value: null,
            feild: {},
        };
        this.inputChange = this.inputChange.bind(this);
        this.inputnumberChange = this.inputnumberChange.bind(this);
        this.inputBlur = this.inputBlur.bind(this);
        this.processChange = this.processChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }
    componentDidMount() {
        let { feild_data } = this.props;
        this.setState({ 'feild': feild_data, 'value': feild_data.value })
    }
    // componentDidUpdate(prevProps, prevState) {
    //     let prev_value = prevState.value
    //     let { feild_data } = this.props;
    //     console.log('prev_value',prev_value,feild_data.value)
    //     if (feild_data.value !== prev_value) {
    //         this.setState({ 'feild': feild_data, 'value': feild_data.value })
    //     }
    // }
    componentWillUnmount() {
        this.setState({
            date: new Date(),
            error: [],
            value: null,
            feild: {}
        })
    }

    processChange = (event) => {
        event.persist();
        if (!this.debouncedFn) {
            this.debouncedFn = debounce(() => {
                this.handleKeyPress(event);
            }, 300);
        }
        this.debouncedFn();
    }
    handleKeyPress(event) {
        let { feild_data } = this.props;
        console.log(feild_data.input_type)
        if (feild_data.type === 'number') {
            let event_value = event.target.value;
            if (event_value >= 0) {
                this.setState({ 'value': event.target.value }, () => {
                    this.inputBlur();
                });
            } else {
                this.inputRef.value = null;
                this.setState({ 'value': 0 }, () => {
                    this.inputBlur();
                });
            }
        } else {
            this.setState({ 'value': event.target.value }, () => {
                this.inputBlur();
            });
        }

    }
    inputChange(evnt) {
        let { feild_data } = this.props;
        if (feild_data.name === 'diagnosis' || feild_data.name === 'name_of_the_fc' || feild_data.name === 'attendant_name' || feild_data.name === 'relation'  || feild_data.name === 'reason_if_denied' || feild_data.name === 'employer_name_company' || feild_data.name === 'remarks'){
            this.setState({ 'value': evnt.target.value }, () => {
                this.inputBlur();
            });
        }
        else if(feild_data.name === 'policy_no' ||feild_data.name ==='call_log_ip_number'){
            let policy_no=evnt.target.value.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '');
                this.setState({ 'value': policy_no }, () => {
                    this.inputBlur();
                });
            
        }
        else if( evnt.target != undefined ){
            this.setState({ 'value': feild_data['value'] }, () => {
                if (feild_data['name'] !== 'qty') {
                    // this.inputBlur();
                }
                if(feild_data.name === 'chapter_colums'){
                    // this.inputBlur();
                }
            });
        }
        // evnt.preventDefault();
    }
    inputnumberChange(value) {
        console.log('value',value,this.props.feild_data)
        let { feild_data } = this.props;
        // this.setState({ 'value': value}, () => {
        //     this.inputBlur();
        // });
        // this.setState({ 'value': value });
        if (this.props.feild_data.name === 'icu_stay' || this.props.feild_data.name === 'room_stay') {
            let event_value = value;
            if (event_value >= 0 && Number.isInteger(event_value)) {
                this.setState({ 'value': value}, () => {
                    this.inputBlur();
                });
            } else {
                this.inputRef.value = null;
                this.setState({ 'value': 0}, () => {
                    this.inputBlur();
                });
            }
        }else{        
            this.inputRef.value = null;
            this.setState({ 'value': value}, () => {
                this.inputBlur();
            });
        }
    }
    inputBlur() {
        console.log('dearch');
        let { value, error } = this.state;
        let { feild_data } = this.props;
        console.log(feild_data, value);
        feild_data['value'] = value;
        feild_data['error'] = error;
        // this.inputChange(feild_data)
        this.props.inputChange(feild_data)
    }

    render() {
        let { feild_data } = this.props;
        let { value } = this.state;
        return (
            <React.Fragment>

                {/* <div className={`${feild_data.class['cols'] ? feild_data.class['cols'] : 'col-12'} form-group ${feild_data.name === 'chapter_colums' ? 'd-grid': ''}`}> */}
                {/* <div className='col-4 mt-3'> */}
                <div className={`${feild_data.className ? feild_data.className + ' align-self-end' : "col-4 mt-3" }`}>
                { feild_data.title ? <label htmlFor={feild_data.name} className="data-label w-100 mb-1 pt-2">{feild_data.title}</label> : null }
                    {/* {feild_data.disable && <p className="form-control mb-0 disable">{feild_data.value }</p>} */}
                    {feild_data.disable && <Input className="mb-0 disable ant-input ant-input-disabled" id={feild_data.name} disabled placeholder={feild_data.placeholder} defaultValue={feild_data.value} value = {feild_data.value} onChange={this.inputChange}/>}
                    {feild_data.disable === false && <React.Fragment>
                        {feild_data.type === 'password' && <Input.Password placeholder={feild_data.placeholder} defaultValue={value} onChange={this.inputChange} id={feild_data.name}/>}
                        {(feild_data.type !== 'number_radio' && feild_data.type !== 'number_normal' && feild_data.type !== 'password' && feild_data.type !== 'inputSubmit' && feild_data.type !== 'number') &&

                            <input type={feild_data.type} className="ant-input" id={feild_data.name} placeholder={feild_data.placeholder} disabled={feild_data.disable ? feild_data.disable : false} defaultValue={value} value={value? value : feild_data.value} onChange={this.inputChange}/>}

                        {/* <Input placeholder={feild_data.placeholder} disabled={feild_data.disable ? feild_data.disable : false} defaultValue={value} onChange={this.inputChange}/> */}


                        {feild_data.type === 'number' && (feild_data.name!=='icu_stay' && feild_data.name!=='room_stay') && <InputNumber ref={(inputRef =>(this.inputRef = inputRef))} 
                            value={feild_data.value} parser={value => value.replace(/\$\s?|(,*)/g, '')} min={0} placeholder={feild_data.placeholder} 
                            // onKeyUp={this.processChange}
                            
                            onChange={this.inputnumberChange} 
                            //  formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            id={feild_data.name}/>}
                        {feild_data.type === 'number' && (feild_data.name==='icu_stay' || feild_data.name==='room_stay') && <InputNumber ref={(inputRef =>(this.inputRef = inputRef))} 
                            value={feild_data.value} parser={value => value.replace(/\$\s?|(,*)/g, '')} min={0} placeholder={feild_data.placeholder} 
                            // onKeyUp={this.processChange}
                           
                            
                            onChange={this.inputnumberChange} 
                             formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            id={feild_data.name}/>
                        }
                        {feild_data.type === 'number_normal' && <InputNumber ref={(inputRef =>(this.inputRef = inputRef))} value={feild_data.value} min={0} placeholder={feild_data.placeholder} onChange={this.inputnumberChange} defaultValue={value} id={feild_data.name}/>}
                        {feild_data.type === 'number_radio' && <Radio.Group defaultValue={feild_data.value} placeholder={feild_data.placeholder} onChange={this.inputChange} id={feild_data.name} >
                            <Radio value={1}>1</Radio>
                            <Radio value={2}>2</Radio>

                        </Radio.Group>}
                        {(feild_data.type === 'inputSubmit') && <Input.Search defaultValue={value} disabled={feild_data.disable ? feild_data.disable : false} placeholder={feild_data.placeholder} enterButton="Submit" onChange={this.inputChange} onSearch={this.inputBlur} id={feild_data.name} />}
                        {/* {(feild_data.error) && <small id={feild_data.name} className="form-text text-danger">{feild_data.error.message}</small>} */}
                        {feild_data.errors.map((error, eKey) => {
                                    return (<small key={eKey} className="form-text text-danger" id={'errorm'+feild_data.name}>{error.message}</small>);
                                })}
                        {/* <input type={feild_data.type} className={feild_data.class['input']} id={feild_data.name} name={feild_data.name} placeholder={feild_data.placeholder} value={feild_data.value} onChange={this.inputChange}/> */}
                    </React.Fragment>}
                </div>

            </React.Fragment>
        );
    }
}

export default Inputlayer;
